/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    currentUser: null
  },
  actions: {
    clearData ({ commit }) {
      commit('setCurrentUser', null)
    }
  },
  mutations: {
    setCurrentUser (val) {
      currentUser = val
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js